import { InMemoryCache } from '@apollo/client'
import { Account } from './type-policies/index.js'

export const createCache = function createCache() {
  return new InMemoryCache({
    typePolicies: {
      ...Account,
    },
  })
}
